import React from 'react';
import { Scale } from 'lucide-react';
import JudgmentIndexPage from '../../pages/prioritization/insights/JudgmentIndexPage';

export const JudgmentIndexLab: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <div className="flex items-center justify-center gap-3">
          <Scale className="h-8 w-8 text-primary-600" />
          <h1 className="text-3xl font-bold text-charcoal-900">Judgment Index (Lab)</h1>
        </div>
        <p className="text-charcoal-600 text-sm max-w-2xl mx-auto">
          Hartman-assessment profiles for your team — individual capacity, team composition, and
          prioritization guidance. Advisory only; does not weight or alter participant input.
        </p>
      </div>
      <JudgmentIndexPage />
    </div>
  );
};
